import React, { useMemo, useState, useCallback, useEffect } from "react";
import { Button } from "react-bootstrap";
import Dropdown from "react-bootstrap/Dropdown";
import search from "../../assets/Vehicles/search.png";
import { Plus, ChevronLeft, ChevronRight } from "lucide-react";
import close from "../../assets/Vehicles/close_filter.png";
import fill_chevron_down from "../../assets/Vehicles/fill_chevron_down.png";
import customize from "../../assets/Vehicles/customize.png";
import down from "../../assets/Vehicles/chevron_down.png";
import Offcanvas from "react-bootstrap/Offcanvas";
import edit from "../../assets/Asssignment/edit.png";
import trash from "../../assets/Asssignment/delete.png";
import closeoff from "../../assets/Asssignment/close.png";
import { useReactTable, getCoreRowModel, getSortedRowModel, getFilteredRowModel, getPaginationRowModel, flexRender } from "@tanstack/react-table";

import MOCK_DATA from "../Vehicles/MOCK_DATA.json";
import "../Vehicles/Vehicle_list/List.css";
import { useNavigate } from "react-router-dom";
import { getVendorListApi } from "./vendor-api.js";
import ReactPaginate from "react-paginate";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import lar from "../../assets/svg/lar.svg";
import rar from "../../assets/svg/rar.svg";
import editIcon from "../../assets/svg/edit.svg";
import delIcon from "../../assets/svg/delete.svg";
import DeleteModal from "../common/delete-modal.js";
import { Toast, ToastContainer } from "react-bootstrap";
import { Tooltip } from "react-tooltip";
import "react-tooltip/dist/react-tooltip.css";
import DatePicker from "react-datepicker";
import { Calendar } from "lucide-react";
import { useGlobal } from "../../GlobalContext.js";

export const VendorList = () => {
  const [activeTab, setActiveTab] = useState("service");
  const { rolePermissionList, userType } = useGlobal();

  const tabButtons = [
    { key: "service", label: "Service expenses" },
    { key: "fuel", label: "Fuel expenses" },
    { key: "other", label: "Other expenses" },
  ];

  const serviceExpense = [
    { label: "Safety system service", value: "₹35,000" },
    { label: "Water wash", value: "₹500" },
    { label: "Engine oil check", value: "₹230" },
  ];
  const fuelExpense = [
    { label: "Petrol", value: "₹2,000" },
    { label: "Diesel", value: "₹3,000" },
    { label: "CNG", value: "₹1,500" },
  ];
  const otherExpense = [
    { label: "Parking", value: "₹200" },
    { label: "Toll", value: "₹500" },
    { label: "Accessories", value: "₹1,200" },
  ];

  const getExpenseData = () => {
    if (activeTab === "service") return serviceExpense;
    if (activeTab === "fuel") return fuelExpense;
    return otherExpense;
  };
  const columns = [
    {
      header: "Vendor ID",
      accessorKey: "vendor_id",
      cell: (info) => (
        <div
          style={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            maxWidth: "150px",
          }}
        >
          {info.getValue()}
        </div>
      ),
    },
    {
      header: "Name",
      accessorKey: "name",
      cell: (info) => (
        <div
          style={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            maxWidth: "200px",
          }}
        >
          {info.getValue()}
        </div>
      ),
    },
    {
      header: "Mobile Number",
      accessorKey: "phone_no",
      cell: (info) => (
        <div
          style={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            maxWidth: "200px",
          }}
        >
          {info.getValue()}
        </div>
      ),
    },
    {
      header: "Email",
      accessorKey: "email",
      cell: (info) => (
        <div
          style={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            maxWidth: "200px",
          }}
        >
          {info.getValue()}
        </div>
      ),
    },
    {
      header: "Description",
      accessorKey: "description",
      cell: (info) => (
        <div
          style={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            maxWidth: "200px",
          }}
        >
          {info.getValue()}
        </div>
      ),
    },
    {
      header: "Address",
      accessorKey: "address",
      cell: (info) => (
        <div
          style={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            maxWidth: "200px",
          }}
        >
          {info.getValue()}
        </div>
      ),
    },

    {
      header: "Status",
      accessorKey: "status",
      cell: (info) => {
        console.log(info);
        return (
          <div
            className="hover-action-cell"
            style={{
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              minWidth: "150px",
            }}
          >
            <span>{info.getValue() === true || info.getValue() === "1" ? "Active" : "InActive"}</span>
            <div className="click-actions">
              {checkPermission("Vendor", "edit_permission") && (
                <button
                  className="icon-btn"
                  onClick={(e) => {
                    e.stopPropagation(); // prevent triggering row click
                    navigate("/vendor/create", {
                      state: { id: info.row.original.id },
                    });
                  }}
                >
                  <img src={editIcon} alt="edit" />
                </button>
              )}
              {checkPermission("Vendor", "delete_permission") && (
                <button
                  className="icon-btn"
                  onClick={(e) => {
                    e.stopPropagation();
                    setDeleteId(info.row.original.id);
                  }}
                >
                  <img src={delIcon} alt="delete" />
                </button>
              )}
            </div>
          </div>
        );
      },
    },
  ];
  function checkPermission(menuName, permission) {
    return rolePermissionList.findIndex((element) => element["name"] === menuName && element["menu_permission"] === true && element[permission] === true) > -1 ? true : false;
  }
  const data = useMemo(() => MOCK_DATA, []);
  const navigate = useNavigate();
  // Global filter (search)
  const [globalFilter, setGlobalFilter] = useState("");

  const sortByList = [
    /* {value:'name asc', label:'Name (Asc)'}, {value:'name desc', label:'Name (Desc)'}, */ {
      value: "created asc",
      label: "Created (Oldest)",
    },
    { value: "created desc", label: "Created (Newest)" },
    { value: "updated asc", label: "Updated Date (Oldest)" },
    { value: "updated desc", label: "Updated Date (Newest)" },
  ];
  const statusList = [
    { value: "", label: "All" },
    { value: "true", label: "Active" },
    { value: "false", label: "In-Active" },
  ];

  const [sortByValue, setSortByValue] = useState({
    value: "created desc",
    label: "Created (Newest)",
  });
  const [sortByField, setSortByField] = useState("created");
  const [sortByDir, setSortByDir] = useState("desc");

  const [phoneNumberFilter, setPhoneNumberFilter] = useState("");
  const [selectedDate, setSelectedDate] = useState();
  const [statusOption, setStatusOption] = useState(null);

  const [tableDataList, setTableDataList] = useState([]);
  const [listCount, setListCount] = useState(null);
  const [pageCount, setPageCount] = useState(0);
  const [itemOffset, setItemOffset] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(10);

  useEffect(() => {
    getDataList();
  }, [itemsPerPage, itemOffset, globalFilter, statusOption, sortByValue, selectedDate]);

  useEffect(() => {
    const handler = setTimeout(() => {
      getDataList();
    }, 500); // 500ms delay

    return () => {
      clearTimeout(handler); // cleanup old timer
    };
  }, [phoneNumberFilter]);

  const getDataList = async () => {
    try {
      /* &from_date=${fromCreatedDate}&to_date=${toCreatedDate}&status=${selectedStatus}&sort_field=${sortField}&sort_dir=${sortDir} */
      const response = await getVendorListApi(`search=${globalFilter}&limit=${itemsPerPage}&skip=${itemOffset * itemsPerPage}&phone_no=${phoneNumberFilter}&status=${statusOption != null ? statusOption.value : ""}&date=${selectedDate != null && selectedDate !== "" ? selectedDate.toLocaleDateString("en-CA") : ""}&sort_field=${sortByField}&sort_dir=${sortByDir}`);
      if (response.data.success === true) {
        setListCount(response.data.total_rec);
        setTableDataList(response.data.vendors);
        setPageCount(response.data.total_pgs);
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };
  const handlePageClick = useCallback((event) => {
    const newOffset = (event.selected * itemsPerPage) % tableDataList.length;
    console.log(`User requested page number ${event.selected}, which is offset ${newOffset}`);
    setItemOffset(event.selected);
  }, []);

  const table = useReactTable({
    data: tableDataList ?? [],
    columns,
    state: {
      globalFilter,
    },
    onGlobalFilterChange: setGlobalFilter,
    getCoreRowModel: getCoreRowModel(),
    getSortedRowModel: getSortedRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
  });
  const { pageIndex, pageSize } = table.getState().pagination;
  const pageOptions = table.getPageOptions();

  const [showRowOffcanvas, setShowRowOffcanvas] = useState(false);
  const [selectedRowData, setSelectedRowData] = useState(null);

  const handleCloseRowOffcanvas = () => setShowRowOffcanvas(false);

  const handleRowClick = (rowData) => {
    navigate("/vendor/view", {
      state: { id: rowData.id, code: rowData.vendor_id },
    });
  };
  const [showSnackbar, setShowSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarStatus, setSnackbarStatus] = useState(null);
  const handleSnackbarShow = () => setShowSnackbar(true);
  const handleSnackbarClose = () => setShowSnackbar(false);

  const [deleteId, setDeleteId] = useState(null);
  const [isOpenDelete, setIsOpenDelete] = useState(false);
  useEffect(() => {
    if (deleteId != null && deleteId !== 0) {
      setIsOpenDelete(true);
    }
  }, [deleteId]);

  const cancelDelete = () => {
    setDeleteId(null);
    setIsOpenDelete(false);
  };
  const onSuccessDelete = (response) => {
    setDeleteId(null);
    setSnackbarMessage(response.message);
    setSnackbarStatus(response.success);
    handleSnackbarShow();
    if (response.success === true) {
      setIsOpenDelete(false);
      getDataList();
    }
  };
  const [hoveredRow, setHoveredRow] = useState(null);
  return (
    <>
      {isOpenDelete && <DeleteModal deleteUrl={`vendor/delete/${deleteId}`} onSuccess={onSuccessDelete} onCancel={cancelDelete} />}
      <div className="bg-half-white w-100">
        <div className=" rounded-4" style={{ background: "#FFFFFF", margin: "16px" }}>
          <div className="d-flex p-3 flex-wrap align-items-center justify-content-between ">
            <div className="d-flex flex-column">
              <p className="bg-transparent fw-bold dark-purple border-0 fs-24 assigned-dropdowns m-0">Vendor</p>
              <p className="text-muted">{listCount} records</p>
            </div>
            <div className="d-flex flex-wrap gap-3">
              <div className="search-wrapper d-flex align-items-center gap-2 bg-white rounded-3 px-3 py-2">
                <img src={search} alt="search" />
                <input type="text" placeholder="Search" className="border-0 outline-0 rounded-3" value={globalFilter || ""} onChange={(e) => setGlobalFilter(e.target.value)} />
              </div>
              {checkPermission("Vendor", "create_permission") && (
                <Button
                  className="dark-purple-btn border-0 d-flex gap-1 px-3 rounded-3 text-white"
                  onClick={() => {
                    navigate("/vendor/create");
                  }}
                >
                  <Plus />
                  Add new
                </Button>
              )}
            </div>
          </div>

          {/* Filters */}
          <div className="d-flex flex-wrap align-items-center justify-content-between p-3 gap-2">
            <div className="d-flex flex-wrap align-items-center gap-3">
              <p className="m-0 text-filter-grey fw-semibold">Filter :</p>
              <Dropdown data-tooltip-id="sort-tooltip" data-tooltip-content="Sort by">
                <Dropdown.Toggle id="dropdown-basic" className="bg-white text-purple search-border assigned-dropdown rounded-4 px-4 d-flex align-items-center gap-2">
                  {sortByValue.label}
                  <img src={fill_chevron_down} alt="chev down" />
                  <img src={close} alt="x" />
                </Dropdown.Toggle>
                <Dropdown.Menu style={{ minWidth: "unset", width: "100%" }}>
                  {sortByList.map((item) => (
                    <Dropdown.Item
                      onClick={() => {
                        const arr = item.value.split(" ");
                        if (arr.length > 1) {
                          setSortByField(arr[0]);
                          setSortByDir(arr[1]);
                        }
                        setSortByValue(item);
                      }}
                    >
                      {item.label}
                    </Dropdown.Item>
                  ))}
                </Dropdown.Menu>
                <Tooltip id="sort-tooltip" place="top" />
              </Dropdown>
              <div style={{ maxWidth: "160px" }} className="search-wrapper d-flex align-items-center gap-2 bg-white search-border rounded-4 px-3 py-2">
                <img src={search} alt="search" />
                <input
                  type="text"
                  placeholder="Phone Number"
                  className="border-0 outline-0 rounded-3 text-purple"
                  value={phoneNumberFilter || ""}
                  onChange={(e) => {
                    const value = e.target.value.replace(/\D/g, "");
                    setPhoneNumberFilter(value);
                  }}
                />
              </div>
              <Dropdown data-tooltip-id="status-tooltip" data-tooltip-content="Status">
                <Dropdown.Toggle id="dropdown-basic" className="bg-white text-purple search-border assigned-dropdown rounded-4 px-4 d-flex align-items-center gap-2">
                  {statusOption != null ? statusOption.label : "Status"} <img src={fill_chevron_down} alt="chev down" />
                </Dropdown.Toggle>
                <Dropdown.Menu style={{ minWidth: "unset", width: "100%" }}>
                  {statusList.map((item) => (
                    <Dropdown.Item
                      onClick={() => {
                        setStatusOption(item);
                      }}
                    >
                      {item.label}
                    </Dropdown.Item>
                  ))}
                </Dropdown.Menu>
                <Tooltip id="status-tooltip" place="top" />
              </Dropdown>
              <div className="w-15 w-md-25 w-lg-18 d-flex align-items-center bg-white text-purple search-border rounded-4" style={{ maxWidth: "180px" }} data-tooltip-id="date-tooltip" data-tooltip-content="Date">
                <DatePicker
                  selected={selectedDate}
                  onChange={(date) => setSelectedDate(date)}
                  dateFormat="dd-mm-yyyy"
                  customInput={
                    <button style={{ color: "#8790A1" }} className="border-0 form-control vehicle-form-input bg-white rounded-4 px-3 py-2 d-flex justify-content-between align-items-center gap-2">
                      {selectedDate ? selectedDate.toLocaleDateString("en-GB").replace(/\//g, "-") : <span style={{ color: "#8790A1" }}>dd-mm-yyyy</span>}
                      <Calendar size={16} />
                    </button>
                  }
                />
                <Tooltip id="date-tooltip" place="top" />
                {selectedDate != null && <img onClick={() => setSelectedDate(null)} src={close} alt="x" style={{ height: "30px" }} />}
              </div>
            </div>
          </div>

          {/* Table */}
          <div className="p-3">
            <div className="table-wrapper overflow-x-auto">
              <table>
                <thead>
                  {table.getHeaderGroups().map((headerGroup) => (
                    <tr key={headerGroup.id}>
                      {headerGroup.headers.map((header) => (
                        <th key={header.id} className="px-3 py-2" onClick={header.column.getToggleSortingHandler()}>
                          {flexRender(header.column.columnDef.header, header.getContext())}
                          {header.column.getIsSorted() === "asc" && " asc"}
                          {header.column.getIsSorted() === "desc" && " des"}
                        </th>
                      ))}
                    </tr>
                  ))}
                </thead>
                <tbody>
                  {table.getRowModel().rows.map((row, index) => (
                    <tr
                      key={row.id}
                      style={{
                        position: "relative",
                        backgroundColor: hoveredRow === index ? "#F9F2FF" : "#ffffff",
                        cursor: "pointer",
                        transition: "border-color 0.3s",
                        borderLeft: hoveredRow === index ? "3px solid #471070" : "3px solid #E5E5E5",
                      }}
                      onMouseEnter={() => setHoveredRow(index)}
                      onMouseLeave={() => setHoveredRow(null)}
                      onClick={() => handleRowClick(row.original)}
                    >
                      {row.getVisibleCells().map((cell) => (
                        <td key={cell.id} className="px-3 py-2">
                          {flexRender(cell.column.columnDef.cell, cell.getContext())}
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            {/* Pagination */}
            <div className="py-3 d-flex justify-content-between align-items-center flex-wrap gap-3">
              <Dropdown>
                <span className="pagination-color">Records per page: &nbsp;</span>
                <Dropdown.Toggle id="dropdown-basic" className="bg-transparent pagination-color  border-0 custom-dropdown-toggle p-0">
                  <span className="bg-white no-of-rows rounded-3 px-2 py-2">
                    {itemsPerPage} <img src={down} alt="" />
                  </span>
                </Dropdown.Toggle>
                <Dropdown.Menu className="my-2" style={{ minWidth: "unset", width: "30%" }}>
                  {[10, 25, 50, 75, 100].map((size) => (
                    <Dropdown.Item
                      key={size}
                      onClick={() => {
                        table.setPageSize(size);
                        setItemsPerPage(size);
                        setItemOffset(0);
                      }}
                      active={itemsPerPage === size}
                      className="text-center"
                    >
                      {size}
                    </Dropdown.Item>
                  ))}
                </Dropdown.Menu>
              </Dropdown>

              <div className="d-flex align-items-center gap-2">
                <ReactPaginate previousLabel={<img src={lar} className="ar3" alt="previous" />} nextLabel={<img src={rar} className="ar3" alt="next" />} breakLabel={"..."} pageCount={pageCount + 1} marginPagesDisplayed={2} pageRangeDisplayed={3} onPageChange={handlePageClick} containerClassName={"pagination"} activeClassName={"active"} />
              </div>
            </div>
          </div>
        </div>
        {/* offcanvas  */}
        <Offcanvas show={showRowOffcanvas} onHide={handleCloseRowOffcanvas} placement="end" style={{ width: "520px" }}>
          <Offcanvas.Header closeButton={false} className="d-flex justify-content-between align-items-center p-0">
            <Offcanvas.Title className="bg-grey w-100 p-3 d-flex flex-wrap justify-content-center align-items-center justify-content-xl-between">
              <div>
                <p className="m-0 fs-20 fw-800 mb-1">TN 10 AV 9807</p>
                <div className="d-flex align-items-center">
                  <span className="me-2 text-muted-grey fs-13 fw-600">Toyota Terminals</span>
                  <span className="me-2" style={{ color: "#D9D9D9" }}>
                    •
                  </span>
                  <span className="border-0 bg-white text-dark-purple py-1 px-4 rounded-pill fs-13 fw-400">
                    <span className="text-muted-grey"> VIN : </span>
                    V123234Q45
                  </span>
                </div>
              </div>
              <div className="d-flex gap-3">
                <img src={edit} alt="edit" className="cursor-pointer" />
                <img src={trash} alt="trash" className="cursor-pointer" />
                <img src={closeoff} alt="closeoff" className="cursor-pointer" onClick={handleCloseRowOffcanvas} />
              </div>
            </Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body>
            {selectedRowData ? (
              <div>
                <div className="row my-3 ">
                  <div className="col-xl-6">
                    <div className="bg-grey rounded-4 p-3 d-flex flex-column align-items-center justify-content-center">
                      <p className="fs-13 fw-400 text-purple">Current KM :</p>
                      <p className="fs-14 fw-600 m-0">1,23,000 km</p>
                    </div>
                  </div>
                  <div className="col-xl-6 mt-3 mt-xl-0">
                    <div className="bg-grey rounded-4 p-3 d-flex flex-column align-items-center justify-content-center">
                      <p className="fs-13 fw-400 text-purple">Last KM : </p>
                      <p className="fs-14 fw-600 m-0">98,000 km</p>
                    </div>
                  </div>
                </div>
                <div className="d-flex flex-wrap align-items-center gap-2 mb-4">
                  {tabButtons.map((tab) => (
                    <button
                      key={tab.key}
                      onClick={() => setActiveTab(tab.key)}
                      className={`px-3 py-2 rounded-pill ${activeTab === tab.key ? "border-0 text-dark-purple" : "pagination-border bg-white"}`}
                      style={{
                        backgroundColor: activeTab === tab.key ? "#EACDFF" : "#fff",
                      }}
                    >
                      {tab.label}
                    </button>
                  ))}
                </div>
                <p className="m-0 fs-15 fw-600">Expenses details</p>

                <div className="table-container rounded-4 overflow-hidden my-3">
                  <table className="table table-borderless mb-0">
                    <tbody>
                      {getExpenseData().map((item, index) => (
                        <tr key={index}>
                          <td className="fs-13 fw-500 w-50" style={{ color: "#49494B" }}>
                            {item.label}
                          </td>
                          <td className="fs-13 fw-400" style={{ color: "#172B4D" }}>
                            {item.value}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            ) : (
              <p>No data available</p>
            )}
          </Offcanvas.Body>
        </Offcanvas>
      </div>
    </>
  );
};
